import React, { Fragment, useContext, useEffect, useState } from "react";
import { Alert, Col, InputGroup, ModalFooter, Row } from "react-bootstrap";
import { Button, Card, CardBody } from "reactstrap";
import ButtonIcon from "../common/ButtonIcon";
import SikkaCardHeader from "../common/SikkaCardHeader";
import Select from "react-select";
import DataTable from "../common/DataTable";
import Loader from "../common/Loader";
import APICall from "../../services/apiCall";
import { toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import AppContext from "../../context/Context";
import ModalCustom from "../common/ModalCustom";
import APIPortalTable from "../common/Table/APIPortalTable";
import SikkaSelect from "../common/SikkaSelect/SikkaSelect";

const styles = {
  control: (base) => ({
    ...base,
    fontSize: "13px",
    minHeight: "35px",
    height: "35px",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "13px",
    zIndex: 9999,
  }),
};

const TransferCustomerModal = ({
  applicationList,
  setTransferCustomerModal,
  devid,
  setUpdateDataFlag,
  applicationDetails,
}) => {
  const [loading, setLoading] = useState(true);
  const [selectedApplication, setSelectedApplication] = useState({});
  const [partnerCustomerList, setPartnerCustomerList] = useState([]);
  const [selectedCustomerForTransfer, setSelectedCustomerForTransfer] = useState([]);
  const [transferConfirmationModal, setTransferConfirmationModal] = useState(false);
  const [applicationListForTranferPrac, setApplicationListForTransferPrac] = useState([]);
  const [partnerRowSelection, setPartnerRowSelection] = useState({});

  useEffect(() => {
    let idx = applicationList.findIndex((data) => data.app_name === applicationDetails.app_name);
    let items = applicationList.map((data) => data);
    items.splice(idx, 1);
    setApplicationListForTransferPrac(items);
    setSelectedApplication({ value: 0, label: items[0].app_name });
  }, [applicationList]);

  const { loginUserDetails } = useContext(AppContext);

  useEffect(() => {
    // partners_customer_list?optflag=1&appid=appid
    setLoading(true);
    setSelectedCustomerForTransfer([]);
    let params = {
      optflag: 1,
      appid: applicationDetails.app_id,
    };

    APICall.servertrip("GET", "partners_customer_list", loginUserDetails, params).then(
      (res) => {
        let items = res.data.items;
        items.forEach((data, index) => (data["idx"] = index));
        setPartnerCustomerList(items);
        setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        toast.error(resMessage);
        setLoading(false);
      }
    );
  }, []);

  const columns = [
    {
      accessorKey: "master_customer_id",
      header: "Master Customer ID",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      csvExport: true,
      sort: true,
    },
    {
      accessorKey: "practice_name",
      header: "Practice Name",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      csvExport: true,
      Cell: ({ cell, row, rowIndex }) => {
        return <div>{row.original.practice_name === "" ? "--" : row.original.practice_name}</div>;
      },
      sort: true,
    },
    {
      accessorKey: "po_user_name",
      header: "User",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      csvExport: true,
      sort: true,
    },
    {
      accessorKey: "authorized_on",
      header: "Authorised Date",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      csvExport: true,
      sort: true,
    },
    {
      accessorKey: "last_refresh",
      header: "SPU Refresh Date",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      csvExport: true,
      Cell: ({ cell, row, rowIndex }) => {
        return <div>{row.original.last_refresh === "01/01/1900 00:00:00" ? "--" : row.original.last_refresh}</div>;
      },
      sort: true,
    },
    {
      accessorKey: "created_date",
      header: "Created Date",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      csvExport: true,
      sort: true,
    },
    {
      accessorKey: "billing_location",
      header: "Practice Location Access",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      csvExport: true,
      Cell: ({ cell, row, rowIndex }) => {
        return <div>{row.original.billing_location === "" ? "--" : row.original.billing_location}</div>;
      },
      sort: true,
    },
    {
      accessorKey: "-",
      header: "API Access",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      csvExport: true,
      sort: true,
    },
  ];

  const handleCustomerTransfer = () => {
    setUpdateDataFlag(false);
    //
    //
    if (selectedCustomerForTransfer.length > 0) {
      setLoading(true);
      let body = {
        existing_app_id: applicationDetails.app_id, //from app_id
        new_app_id: applicationList.filter((app) => app.app_name === selectedApplication.label)[0].app_id, // to app_id
        transfer_practices: selectedCustomerForTransfer.map((cust) => cust.master_customer_id),
        transfer_option: "remove", // fix vlaue for now
        add_updated_by: loginUserDetails.user_name,
        is_add_updated_by_admin: loginUserDetails.is_partner === "0" ? "true" : "false",
        existing_app_name: selectedCustomerForTransfer[0].app_name, //from app_name
        dev_id: devid,
        partner_name: selectedCustomerForTransfer[0].partner_name,
        new_app_name: selectedApplication.label, //to app_name
      };
      APICall.servertrip("POST", "transfer_practices", loginUserDetails, undefined, body).then(
        (res) => {
          setLoading(false);
          setUpdateDataFlag(true);
          setTransferConfirmationModal(false);
          setTransferCustomerModal(false);
        },
        (error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          toast.error(resMessage);
          setLoading(false);
          setUpdateDataFlag(true);
        }
      );
    } else {
      toast.warning("Please select a customer to continue.");
    }
  };

  useEffect(() => {
    const partnerRowSelectionKeys = Object.keys(partnerRowSelection);

    const selectedPartnerRow = partnerRowSelectionKeys.map((item, itemIndex) => {
      let findItemIndex = partnerCustomerList.findIndex((Pcitem) => {
        return `${Pcitem.idx}` === `${item}`;
      });

      return partnerCustomerList[findItemIndex];
    });

    setSelectedCustomerForTransfer(selectedPartnerRow);
  }, [partnerRowSelection]);

  return (
    <div className="p-0">
      <>
        <Col className="mt-2">
          <InputGroup>
            <InputGroup.Text
              style={{
                borderTopLeftRadius: "5px",
                borderBottomLeftRadius: "5px",
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
              }}
              className="fs--1"
            >
              <div className="h6 m-0 text-700" style={{ color: "#5e6e82" }}>
                Select Application:
              </div>
            </InputGroup.Text>
            <Col className={"col-12 col-sm-10 col-md-6 col-lg-6 p-0"}>
              <SikkaSelect
                // styles={styles}
                classNamePrefix="react-select"
                options={applicationListForTranferPrac.map((app, index) => {
                  return {
                    value: index,
                    label: app.app_name,
                  };
                })}
                value={selectedApplication}
                isLoading={!applicationListForTranferPrac.length}
                onChange={(selectedOption) => setSelectedApplication(selectedOption)}
              />
            </Col>
          </InputGroup>
        </Col>

        <>
          <APIPortalTable
            data={partnerCustomerList}
            columns={columns}
            loading={loading}
            enablePagination
            CSVFileName={"Transfer Customer Data Details.csv"}
            enableRowSelection
            getRowId={(row) => row.id} //give each row a more useful id
            onRowSelectionChange={setPartnerRowSelection} //connect internal row selection state to your own
            state={{ rowSelection: partnerRowSelection }}
            enableMultiRowSelection={true}
            enableSelectAll={true}
            selectAllMode="all"
          />
        </>
      </>
      <div className="modal-footer bg-light m-1" style={{ marginBottom: "-16px" }}>
        <Button
          color="outline-primary"
          size="sm"
          className="ml-auto"
          type="submit"
          onClick={() => {
            if (selectedCustomerForTransfer.length > 0) {
              setTransferConfirmationModal(true);
            } else {
              toast.warning("Please select a customer to continue.");
            }
          }}
        >
          Save
        </Button>
        <Button
          color="outline-danger"
          size="sm"
          onClick={() => {
            setTransferCustomerModal(false);
          }}
        >
          Cancel
        </Button>
      </div>
      <ModalCustom
        title="Transfer Practices"
        openPopup={transferConfirmationModal}
        setOpenPopup={setTransferConfirmationModal}
        size="md"
      >
        <Alert color="info">Are you sure you want to transfer selected practice(s)?</Alert>
        <div className="modal-footer bg-light m-1" style={{ marginBottom: "-16px" }}>
          <Button color="outline-primary"
           size="sm" 
           className="ml-auto" 
           onClick={handleCustomerTransfer}>
            Yes
          </Button>
          <Button
            color="outline-danger"
            size="sm"
            onClick={() => {
              setTransferConfirmationModal(false);
            }}
          >
            No
          </Button>
        </div>
      </ModalCustom>
    </div>
  );
};

export default TransferCustomerModal;
